import { useTranslation } from 'react-i18next';
import CheckRounded from '@mui/icons-material/CheckRounded';
import Close from '@mui/icons-material/Close';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

import { useSystemsContextProvider } from 'features/systems/context/systems-provider';
import styles from 'features/systems/views/details/system-details-popup-header.module.scss';

type Props = {
  resetForm?: () => void;
};

const SystemDetailsPopupHeader = ({ resetForm }: Props) => {
  const { t } = useTranslation('systems');
  const { hasPermission } = usePermissionAuthorization();

  const { systemsDetailsHook } = useSystemsContextProvider();
  const { cancelMutation, mutationIsLoading, deleteSystem, closeDetails, openDetailsInEditingMode, selectedSystem, viewingMode } =
    systemsDetailsHook;

  const isViewing = viewingMode === 'viewing';
  const isEditing = viewingMode === 'editing';

  return (
    <div className={styles.container}>
      {isEditing && (
        <>
          <Button
            variant="text"
            onClick={() => {
              cancelMutation();
              resetForm?.();
            }}
            disabled={mutationIsLoading}
          >
            {t('details.action.cancel')}
          </Button>
          <Button startIcon={<CheckRounded />} variant="contained" type="submit" loading={mutationIsLoading} loadingPosition="start">
            {t('details.action.save')}
          </Button>
        </>
      )}
      {isViewing && (
        <>
          {hasPermission(Permission.DeleteSystems) && (
            <Button
              startIcon={<DeleteForeverOutlinedIcon />}
              variant="text"
              onClick={() => selectedSystem && deleteSystem(selectedSystem)}
              disabled={mutationIsLoading}
            >
              {t('details.action.remove')}
            </Button>
          )}
          {hasPermission(Permission.UpdateSystems) && (
            <Button
              startIcon={<ModeEditOutlineOutlinedIcon />}
              variant="text"
              onClick={() => openDetailsInEditingMode(selectedSystem?.id)}
              disabled={mutationIsLoading}
            >
              {t('details.action.edit')}
            </Button>
          )}
        </>
      )}

      <IconButton aria-label="close" className={styles.closeButton} onClick={closeDetails}>
        <Close />
      </IconButton>
    </div>
  );
};

export default SystemDetailsPopupHeader;
